import * as React from "react";

import { Input, Button } from "src/components";
import { IAddFieldProps, IAddFieldState } from "../types";

class AddField extends React.Component<IAddFieldProps, IAddFieldState> {
  state = {
    value: "",
    isValid: false,
    isAdding: false,
  };

  onInput = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    this.setState({
      value,
      isValid: this.isValid(value),
    });
  };

  isValid = (value: string) => {
    const { regex } = this.props;
    if (value.length === 0) {
      return false;
    }
    if (regex) {
      return Boolean(value.trim().match(regex));
    }
    return true;
  };

  onSubmit = async () => {
    if (!this.state.isValid) {
      return;
    }
    const { id, onAdd } = this.props;
    this.setState({
      isAdding: true,
    });
    await onAdd(id, this.state.value.trim());
    this.setState({
      value: "",
      isAdding: false,
    });
  };

  render() {
    return (
      <div>
        <div className="flex mt-4">
          <Input
            className="flex-1 mr-3"
            value={this.state.value}
            onChange={this.onInput}
          />
          <Button
            type="button"
            size="small"
            onClick={this.onSubmit}
            loading={this.state.isAdding}
            loadingLabel="Adding"
            disabled={!this.state.isValid}
          >
            Add
          </Button>
        </div>
        {!this.state.isValid && this.state.value && (
          <div className="mt-1 pt-1 text-xs text-red">
            {this.props.errorMessage}
          </div>
        )}
      </div>
    );
  }
}

export default AddField;



// WEBPACK FOOTER //
// ./src/views/LinkCreate/components/AddField.tsx